import { LegalPersonalityEnum, LegalPersonalityIdEnum } from 'src/app/domain/enums/legal-personality.enum';
import { RegimeTypeIdEnum } from 'src/app/domain/registration/enums/regime-type.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';

export class FormDataUpdate {
  public async build(element: any): Promise<FormData> {
    let {
      id,
      image,
      legalPersonality,
      name,
      birthday,
      cnpj,
      cpf,
      companyName,
      tradingName,
      generalRegistration,
      stateRegistration,
      municipalRegistration,
      regime,
      phone,
      cellPhone,
      email,
      webSite,

      cep,
      address,
      addressComplement,
      addressNumber,
      neighborhood,
      state,
      city,
      addressObservation,
      country,

      loginScreenLogo,
      supportContact,
      webSiteLink,
      comment,
      partnerCommission,
      consultantCommission,
      representativeCommission,
      counterCommission,
      unitCommission,
      isConsultant,
      isPartner,
      isRepresentative,
      isCounter,
      isUnit,
      isSupplier,
      consultant,
      partner,
      representative,
      cutoffDay,
      transferDay,
      isMerchant
    } = element;

    let formData = new FormData();

    formData.append('id', id);

    if (image !== undefined && image !== null && image !== '') {
      if (typeof image === 'string' && image.toLowerCase().indexOf(';base64') != -1) {
        try {
          formData.append(
            'image',
            new File(
              [await GlobalUtils.blobImageFromBase64String(image)],
              image?.toLowerCase().indexOf('png') != -1
                ? `filename.png`
                : `filename.jpeg`
            )
          );
        } catch (error) {
          console.error('Error processing image:', error);
          // Se houver erro ao processar a imagem, adiciona a imagem original
          formData.append('image', image);
        }
      } else {
        formData.append('image', image);
      }
    }

    formData.append('legalPersonality', legalPersonality);

    if (
      legalPersonality ===
      LegalPersonalityIdEnum[LegalPersonalityEnum.PESSOA_FISICA]
    ) {
      formData.append('cpf', cpf);
      formData.append('name', name?.toUpperCase());
      const formattedBirthday = birthday ? new Date(birthday).toISOString().split('T')[0] : '';
      formData.append('birthday', formattedBirthday);
      formData.append('generalRegistration', generalRegistration);
    } else {
      formData.append('cnpj', cnpj);
      formData.append('companyName', companyName?.toUpperCase());
      formData.append('stateRegistration', stateRegistration);
      formData.append('municipalRegistration', municipalRegistration);
    }

    formData.append('tradingName', tradingName?.toUpperCase());
    formData.append('regime', RegimeTypeIdEnum[regime]);
    formData.append('phone', phone);
    formData.append('cellPhone', cellPhone);
    formData.append('email', email);
    formData.append('webSite', webSite);

    formData.append('cep', cep);
    formData.append('address', address);
    formData.append('addressComplement', addressComplement);
    formData.append('addressNumber', addressNumber);
    formData.append('neighborhood', neighborhood);
    formData.append('state', state);
    formData.append('city', city);
    formData.append('addressObservation', addressObservation);
    formData.append('country', country);

    if (loginScreenLogo && loginScreenLogo.toLowerCase().indexOf(';base64') != -1) {
      formData.append(
        'loginScreenLogo',
        new File(
          [await GlobalUtils.blobImageFromBase64String(loginScreenLogo)],
          loginScreenLogo?.toLowerCase().indexOf('png') != -1
            ? `loginScreenLogo.png`
            : `loginScreenLogo.jpeg`
        )
      );
    } else if (loginScreenLogo) {
      formData.append('loginScreenLogo', loginScreenLogo);
    }

    formData.append('supportContact', supportContact);

    [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ].forEach((day) => {
      formData.append(
        `check${day}BusinessHour`,
        element[`check${day}BusinessHour`]
      );
      formData.append(
        `start${day}BusinessHour`,
        element[`start${day}BusinessHour`]
      );
      formData.append(
        `end${day}BusinessHour`,
        element[`start${day}BusinessHour`]
      );
    });

    formData.append('webSiteLink', webSiteLink);
    formData.append('comment', comment);
    formData.append('partnerCommission', partnerCommission);
    formData.append('consultantCommission', consultantCommission);
    formData.append('representativeCommission', representativeCommission);
    formData.append('counterCommission', counterCommission);
    formData.append('unitCommission', unitCommission);

    formData.append('isConsultant', isConsultant);
    formData.append('isPartner', isPartner);
    formData.append('isRepresentative', isRepresentative);
    formData.append('isCounter', isCounter);
    formData.append('isUnit', isUnit);
    formData.append('isSupplier', isSupplier);
    formData.append('isMerchant', isMerchant);

    formData.append('consultant', consultant);
    formData.append('partner', partner);
    formData.append('representative', representative);
    formData.append('cutoffDay', cutoffDay);
    formData.append('transferDay', transferDay);

    return formData;
  }
}
